/**
 * Internal dependencies
 */
import WMUWCAddress from './address';

/**
 * 
 */
const addressList = [];

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	if ( wmuwcAddressArgs && wmuwcAddressArgs.contexts )
	{
		wmuwcAddressArgs.contexts.forEach( ( context ) =>
		{
			const contextElement = document.querySelector( context.elementSelector );

			if ( contextElement )
			{
				addressList.push( new WMUWCAddress( {
					contextElement: document.querySelector( context.elementSelector ),
					countryLocale: wmuwcAddressArgs.countryLocale,
					fieldCountrySelector: context.fieldCountrySelector,
					fieldPostcodeDefaults: wmuwcAddressArgs.fieldDefaults.postcode,
					fieldPostcodeSelector: context.fieldPostcodeSelector,
					fieldStateDefaults: wmuwcAddressArgs.fieldDefaults.state,
					fieldStateSelector: context.fieldStateSelector,
				} ) );
			}
		} );
	}
} );